var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEntitlementActive = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "1 1 18 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#entitlement-active_svg__a)",
  d: "M10 17.6c4.165 0 7.54-3.403 7.54-7.6 0-4.197-3.375-7.6-7.54-7.6S2.459 5.803 2.459 10c0 4.197 3.376 7.6 7.54 7.6Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.089,
  d: "M10.001 13.63s2.903-1.453 2.903-3.63V7.46l-2.903-1.09-2.903 1.09V10c0 2.178 2.903 3.63 2.903 3.63Z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "entitlement-active_svg__a",
  x1: 2.459,
  x2: 17.541,
  y1: 10,
  y2: 10,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E22862"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#916EE7"
})))));
export default SvgEntitlementActive;